import { MessageDescriptor } from 'react-intl';

import {
  getDictationRefusal,
  TRANSCRIPTION_DISABLED_CODE,
} from '@/shared/api/transcriptor';

import { dictationRefusalMessages, transcriptorMessages } from '../config';

// `unwrap()` throws the action's serialized error — a plain object carrying
// name/message/stack/code — so an instanceof check never matches what a
// rejected thunk hands its caller. Reading the field covers both that shape and
// a real Error.
export const getTranscriptorErrorText = (
  error: unknown,
): string | undefined => {
  if (typeof error === 'string') {
    return error.trim() || undefined;
  }

  if (typeof error === 'object' && error !== null && 'message' in error) {
    const { message } = error as { message?: unknown };

    if (typeof message === 'string' && message.trim()) {
      return message;
    }
  }

  return undefined;
};

export const getErrorMessage = (error: unknown): string =>
  getTranscriptorErrorText(error) ?? 'An unknown error occurred';

export const getTranscriptorErrorMessage = (
  error: unknown,
): MessageDescriptor | undefined => {
  const code =
    typeof error === 'object' && error !== null && 'code' in error
      ? (error as { code?: unknown }).code
      : undefined;

  if (code === TRANSCRIPTION_DISABLED_CODE) {
    return transcriptorMessages.transcriptionDisabled;
  }

  const dictationRefusal = getDictationRefusal(error);

  return dictationRefusal && dictationRefusalMessages[dictationRefusal];
};
